<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <h3 v-dynamic-content:financing_header_how_does_it_work class="mb-4"></h3>

      <ul>
        <li v-dynamic-content:financing_how_does_it_work_bullet_one></li>
        <li v-dynamic-content:financing_how_does_it_work_bullet_two></li>
        <li v-dynamic-content:financing_how_does_it_work_bullet_three></li>
      </ul>

      <div class="row mt-7">
        <div class="visual-calculation mr-auto">
          <div class="row">
            <div
              v-dynamic-content:financing_calculation_visual_monthly_savings
              class="col-auto"
            ></div>
          </div>
          <div class="row">
            <div
              v-dynamic-content:financing_calculation_visual_monthly_payments
              class="col-auto"
            ></div>
            <div class="minus">-</div>
          </div>

          <div v-dynamic-content:financing_calculation_visual_monthly_benefits class="sum"></div>
        </div>
      </div>

      <p v-dynamic-content:financing_description_partial_amount class="mt-7"></p>

      <table>
        <thead>
          <tr>
            <th v-dynamic-content:financing_table_heading_credit_amount></th>
            <th v-dynamic-content:financing_table_heading_monthly_payments></th>
          </tr>
        </thead>
        <tr v-for="set in creditAmounts" :key="set[0]">
          <td>{{ set[0] | formatCurrency }}</td>
          <td>{{ set[1] | formatCurrency }}</td>
        </tr>
      </table>

      <p v-dynamic-content:financing_asterix_one class="disclaimer"></p>
      <p v-dynamic-content:financing_asterix_two class="disclaimer"></p>
    </div>
    <div class="col">
      <div class="your-system">
        <h5 v-dynamic-content:financing_system_details_header></h5>

        <ul>
          <li v-dynamic-content:financing_system_details_total_price_bullet="[totalAmount]"></li>
          <li
            v-dynamic-content:financing_system_details_average_yearly_saving_bullet="[
              averageYearlySavings,
            ]"
          ></li>
          <li
            v-dynamic-content:financing_system_details_average_monthly_saving_bullet="[
              averageMonthlySavings,
            ]"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      creditAmounts: [
        [3000, 28],
        [4000, 37],
        [5000, 46],
        [6000, 55],
        [7000, 64],
        [8000, 74],
        [9000, 83],
        [10000, 92],
      ],
    }
  },
  computed: {
    totalAmount() {
      return this.formatCurrency(this.quote.detailOverview.contractPrice)
    },
    totalVatAmount() {
      return this.formatCurrency(this.quote.detailOverview.valueAddedTaxBeforeDiscount)
    },
    averageYearlySavings() {
      return this.formatCurrency(this.quote.detailOverview.annualSavingsCumulative[9] / 10)
    },
    averageMonthlySavings() {
      return this.formatCurrency(this.quote.detailOverview.annualSavingsCumulative[9] / 120)
    },
  },
  methods: {
    formatCurrency(val) {
      return this.$options.filters.formatCurrency(val)
    },
  },
}
</script>

<style scoped>
.visual-calculation {
  background-image: url('../../assets/icons/icon-premies.svg');
  background-repeat: no-repeat;
  background-position-y: 2rem;
  padding-left: 4rem;
}
.visual-calculation div.row {
  margin-bottom: 0.5rem;
}
div.sum {
  border-top: 2px solid black;
  padding-top: 0.5rem;
  font-weight: bold;
}
.minus {
  font-weight: 100;
  font-size: 2.5rem;
  line-height: 1.5rem;
}
ul {
  padding-left: 1.5rem;
}
li {
  line-height: 2rem;
  margin-bottom: 0.5rem;
}
.your-quote {
  background-color: rgba(150, 187, 195, 0.2);
  border-radius: 5px;
  padding: 1rem;
}
.your-quote ul {
  font-size: 0.9rem;
}
table {
  margin-bottom: 2rem;
  padding: 1rem;
  width: 100%;
}
th,
td {
  border: 1px solid #dde1e9;
  padding: 1rem;
}
</style>
